var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"reference-letter-documents"},[_c('p',[_vm._v("Bijlagen")]),_vm._v(" "),_c('document-panel',{attrs:{"documents":_vm.formattedDocuments,"canDownload":true},on:{"onSuccess":_vm.onSuccessfullUpload,"onError":_vm.onUploadError,"deleteDocument":_vm.handleDeleteDocument}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }